import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const serviceName = 'foodie-menu-service';
export const GetAllMeals = createAsyncThunk('menu/GetAllMeals ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${serviceName}/v1/meals/get-all/`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const GetAllMealTimes = createAsyncThunk('menu/GetAllMealTimes ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${serviceName}/v1/meal-times/get-all`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const GetAllCourseType = createAsyncThunk('menu/GetAllCourseType ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${serviceName}/v1/courses/get-all`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const GetAllItem = createAsyncThunk('menu/GetAllItem ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${serviceName}/v1/items/get-all`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetMenuById = createAsyncThunk('menu/GetMenuById ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${serviceName}/v1/menus/by-id/${params}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const CreateMenu = createAsyncThunk('menu/CreateMenu', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .post(`${serviceName}/v1/menus/create`, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});
export const UpdateMenu = createAsyncThunk('menu/UpdateMenu', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .put(`${serviceName}/v1/menus/update`, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});
export const GetMenuByCafeteriaIdServingDate = createAsyncThunk(
    'menu/GetMenuByCafeteriaIdServingDate',
    async ({ cafeteriaId, servingDate, pagination }, { dispatch, getState }) => {
        const response = await apiInstance
            .post(`${serviceName}/v1/menus/by-cafeteria-id/${cafeteriaId}/${servingDate}`, pagination)
            .then(function (response) {
                return response;
            })
            .catch((error) => error.response);

        const { data, status, code } = response;
        return { data, status, code };
    },
);

export const DeleteDepartmentById = createAsyncThunk(
  'menu/deleteDepartmentById',
  async ({foodieMenuId, departmentId }, { dispatch, getState }) => {
    const response = await apiInstance
      .delete(`${serviceName}/v1/menus/${foodieMenuId}/remove-department/${departmentId}`)
      .catch((error) => error.response);

    const { data, status } = response;
    return { data, status };
  }
);
export const DeleteMealTimeById = createAsyncThunk(
  'menu/deleteMealTimetById',
  async ({foodieMenuId, mealTimeId }, { dispatch, getState }) => {
    const response = await apiInstance
      .delete(`${serviceName}/v1/menus/${foodieMenuId}/remove-meal-time/${mealTimeId}`)
      .catch((error) => error.response);

    const { data, status } = response;
    return { data, status };
  }
);
export const DeleteUserById = createAsyncThunk(
  'menu/deleteUserById',
  async ({foodieMenuId, userId }, { dispatch, getState }) => {
    const response = await apiInstance
      .delete(`${serviceName}/v1/menus/${foodieMenuId}/remove-user/${userId}`)
      .catch((error) => error.response);

    const { data, status } = response;
    return { data, status };
  }
);

export const GetAllMealForecast = createAsyncThunk(
    'menu/getAllMealForecast',
    async (params, { dispatch, getState }) => {
        const response = await apiInstance
            .post(`${serviceName}/v2/forecast/get`, params)
            .then(function (response) {
                return response;
            })
            .catch((error) => error.response);

        const { data, status, code } = response;
        return { data, status, code };
    },
);
